(function () {
  var MEMBERSHIP_VARIANT_ID = 41187871457338;
  var DEFAULT_SELLING_PLAN_ID = 2550104122;
  var CASHBACK_SELECTOR = '[data-vip-cashback]';
  var BUTTON_SELECTOR = '[data-membership-variant][data-membership-selling-plan], .drawer-upsell-button';

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
  }

  async function fetchCart() {
    var response = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Unable to load cart from /cart.js');
    }

    return response.json();
  }

  function getMembershipCents(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return item.variant_id === MEMBERSHIP_VARIANT_ID ? sum + item.final_line_price : sum;
    }, 0);
  }

  function updateCashbackDisplay(cart) {
    var membershipLinePrice = getMembershipCents(cart);
    var eligibleTotal = Math.max(0, (cart.total_price || 0) - membershipLinePrice);
    var cashbackCents = Math.round(eligibleTotal * 0.2);
    var text = formatMoney(cashbackCents, cart.currency);

    document.querySelectorAll(CASHBACK_SELECTOR).forEach(function (node) {
      node.textContent = text;
    });
  }

  function cartContainsMembership(cart) {
    return (cart.items || []).some(function (item) {
      return item.variant_id === MEMBERSHIP_VARIANT_ID;
    });
  }

  function updateButtonState(cart) {
    var hasMembership = cartContainsMembership(cart);

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var variantId = Number(button.dataset.membershipVariant || button.getAttribute('data-membership-variant'));

      if (variantId !== MEMBERSHIP_VARIANT_ID) {
        return;
      }

      if (hasMembership) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.textContent = 'Added to Cart';
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
        }
      }
    });
  }

  async function refreshVipUI() {
    try {
      var cart = await fetchCart();
      updateCashbackDisplay(cart);
      updateButtonState(cart);
    } catch (error) {
      console.error('[membership-upsell] refresh failed', error);
    }
  }

  async function addMembershipToCart(button) {
    var variantId = button.dataset.membershipVariant || String(MEMBERSHIP_VARIANT_ID);
    var sellingPlanId = button.dataset.membershipSellingPlan || String(DEFAULT_SELLING_PLAN_ID);

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      var body = new URLSearchParams({
        id: variantId,
        quantity: '1',
        selling_plan: sellingPlanId,
      }).toString();

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: body,
      });

      if (!response.ok) {
        var errorText = await response.text();
        throw new Error(errorText || 'Unable to add membership');
      }

      await refreshVipUI();

      document.dispatchEvent(new CustomEvent('membership-upsell:added'));
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  function resolveMembershipButton(target) {
    if (!target) return null;
    var button = target.closest(BUTTON_SELECTOR);
    if (!button) return null;

    var variantId = Number(button.dataset.membershipVariant || button.getAttribute('data-membership-variant'));
    var sellingPlanId = Number(button.dataset.membershipSellingPlan || button.getAttribute('data-membership-selling-plan'));

    if (!variantId || !sellingPlanId) return null;
    return button;
  }

  document.addEventListener('click', function (event) {
    var button = resolveMembershipButton(event.target);
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('disabled') || button.getAttribute('aria-busy') === 'true') {
      return;
    }

    addMembershipToCart(button).catch(function (error) {
      console.error('[membership-upsell] add to cart failed', error);
    });
  });

  window.addEventListener('aftersell-upcart:public-events:cart-loaded', function () {
    refreshVipUI();
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldRefresh = mutations.some(function (mutation) {
      return mutation.addedNodes && mutation.addedNodes.length > 0;
    });

    if (shouldRefresh) {
      refreshVipUI();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  refreshVipUI();
})();